import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';

var config = {
  apiKey: "AIzaSyChoJPE26zIMOYk8Iu2-n5LgZafZts20-M",
  authDomain: "plum-village.firebaseapp.com",
  databaseURL: "https://plum-village.firebaseio.com",
  storageBucket: "plum-village.appspot.com",
  messagingSenderId: "552620441503"
};

firebase.initializeApp(config);

const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storageKey = 'plum_village_admin:user:uid';
const isAuthenticated = () => {
  return !!auth.currentUser || !!localStorage.getItem(storageKey);
}

const database = firebase.database();
const getRef = (path) => {
  return database.ref(path);
}

const getPostRef = (id, visibility = 'public') => {
  return getRef(`/content/posts/${visibility}/${id}`);
}
const getPostIndexRef = (visibility = '') => {
  return getRef(`/content/posts/${visibility}`);
}

const getFolderIndexRef = () => {
  return getRef('/content/folders');
}
const getFolderRef = (id) => {
  return getRef(`/content/folders/${id}`);
}

const getFileIndexRef = () => {
  return getRef('/content/files');
}

const getMediaStorageRef = () => {
  return firebase.storage().ref('/media');
}

export {
  firebase,
  auth,
  provider,
  storageKey,
  isAuthenticated,
  database,
  getRef,
  getPostRef,
  getPostIndexRef,
  getFolderIndexRef,
  getFolderRef,
  getFileIndexRef,
  getMediaStorageRef,
}



// WEBPACK FOOTER //
// ./src/config/firebase.js